import { LitElement, css, html } from 'lit'


// простой переключатель содержимого слота

export class DzRcSelect extends LitElement {
    static get properties() {
        return {
          selector: { type: String },
        }
    }

    render() {
        return html`<slot name="${this.selector}"></slot>`
    }

    updated() {
        let slot = this.shadowRoot.querySelector('slot')
        if (slot.assignedElements().length) {
            this.style.display = `block`
        } else {
            this.style.display = `none`
        }
    }

    static get styles() {
        return css`
            :host {
                display: block;
            }
    `}
}

window.customElements.define('dz-rc-select', DzRcSelect)